import { render, staticRenderFns } from "./sala-mensajes.vue?vue&type=template&id=15149193&scoped=true&"
import script from "./sala-mensajes.vue?vue&type=script&lang=ts&"
export * from "./sala-mensajes.vue?vue&type=script&lang=ts&"
import style0 from "./sala-mensajes.vue?vue&type=style&index=0&id=15149193&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15149193",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VProgressLinear,VRow})
